import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from 'eddydata-lib';
import { PagamentoLstComponent } from './pagamento-lst/pagamento-lst.component';
import { PagamentoShwComponent } from './pagamento-shw/pagamento-shw.component';

const routes: Routes = [
  {
    path: 'pesquisa/:pagina/:data1/:data2',
    component: PagamentoLstComponent, canActivate: [AuthGuard]
  },
  {
    path: 'pesquisa/:pagina/:data1/:data2/:filtro',
    component: PagamentoLstComponent, canActivate: [AuthGuard]
  },
  {
    path: 'visualiza/:id/:pagina/:data1/:data2',
    component: PagamentoShwComponent, canActivate: [AuthGuard]
  },
  {
    path: 'visualiza/:id/:pagina/:data1/:data2/:filtro',
    component: PagamentoShwComponent, canActivate: [AuthGuard]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PagamentoRoutingModule { }

